<template>
  <div>
    <div>
      <b-modal
        id="reservation-modal"
        v-model="modalShow"
        centered
        hide-header
        hide-footer
        ok-disabled
        cancel-disabled
      >
        <div class="d-block text-center modal-container">
          <div class="content-header">
            {{ reservation.name || '確認中...' }}
          </div>
          <dl>
            <div class="content-desc">
              <dt class="content-desc-heading">{{ $t('preOrder.receptionNumber') }}</dt>
              <dd class="content-desc-body">{{ reservation.registNumber || '-' }}</dd>
            </div>
            <div class="content-desc">
              <dt class="content-desc-heading">{{ $t('preOrder.reservationUsherTime') }}</dt>
              <dd class="content-desc-body">{{ formattedTime || '-' }}</dd>
            </div>
            <div class="content-desc">
              <dt class="content-desc-heading">{{ $t('preOrder.numberOfReservations') }}</dt>
              <dd class="content-desc-body">{{ reservation.numberOfPersons || '-' }}</dd>
            </div>
          </dl>
          <div>
            <b-row class="buttons">
              <b-col>
                <div>
                  <so-close-button @click="handleClose">{{ $t('common.close') }}</so-close-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

import SoCloseButton from '@/components/common/SoCloseButton'

export default {
  name: 'ReserveInfoModal',
  components: {
    SoCloseButton,
  },
  computed: {
    ...mapGetters({
      isShowingReserveInfoModal: 'modal/isShowingReserveInfoModal',
      reservation: 'reservation/getReserveInfo',
    }),
    modalShow: {
      get() {
        return this.isShowingReserveInfoModal
      },
      set(value) {
        this.$store.dispatch('modal/setShowingReserveInfoModal', value)
      },
    },
    formattedTime() {
      const dateTime = this.reservation.displayTime
      if (!dateTime) return ''
      try {
        return dateTime.split(' ')[1].replace(/～|〜/, ' ～ ')
      } catch (err) {
        return dateTime
      }
    },
  },
  methods: {
    handleClose() {
      this.$store.dispatch('modal/setShowingReserveInfoModal', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-container {
  padding-top: 8px;
}
.content {
  color: #222222;

  &-header {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 16px;
  }

  &-desc {
    padding: 16px 0 0;
    font-size: 12px;

    &-heading {
      font-weight: normal;
    }

    &-body {
      font-weight: bold;
      font-size: 24px;
    }
  }
}
.col {
  padding-left: 4px;
  padding-right: 4px;
}
.buttons {
  margin-top: 20px;
}
</style>
